import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, HREF_FIELD, TITLE_FIELD } from "../commonFields";

export const breadcrumbsBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Breadcrumbs",
  description:
    "A navigation component that displays the user's location within a site.",
  inputs: [
    {
      name: "homeLink",
      type: "object",
      subFields: [
        {
          ...HREF_FIELD,
          defaultValue: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "/",
          },
        },
        { ...DLD_FIELD, defaultValue: "SolarWinds Home", required: false },
        { ...DLT_FIELD, defaultValue: "Breadcrumb", required: false },
      ],
      required: false,
      defaultValue: { dld: "SolarWinds Home", dlt: "Breadcrumb" },
    },
    {
      name: "links",
      type: "list",
      subFields: [
        TITLE_FIELD,
        { ...HREF_FIELD, required: false },
        { ...DLD_FIELD, required: false },
        { ...DLT_FIELD, required: false },
      ],
      required: true,
      defaultValue: [],
    },
  ],
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  noWrap: true,
};
